import React from 'react';
import { Image, ImageStyle, StyleProp, StyleSheet } from 'react-native';

/** Intrinsic size of the artwork, so the box never distorts it. */
const ASPECT = 215 / 135;

type Props = {
  /** Rendered height in points; width follows from the artwork's aspect. */
  height?: number;
  style?: StyleProp<ImageStyle>;
};

/**
 * The Homingo lockup - flower mark above the wordmark.
 *
 * Drawn from `logo_transparent.png`, which is the supplied `logo.png` with its
 * flat pale-green backing keyed out and the surrounding padding trimmed. The
 * original shipped as an opaque square, which would have sat on the canvas as
 * a visible tile; the keyed copy sits on any background. Both files are kept.
 */
function Logo({ height = 40, style }: Props) {
  return (
    <Image
      source={require('../../assets/uploads/logo/logo_transparent.png')}
      style={[styles.logo, { height, width: height * ASPECT }, style]}
      resizeMode="contain"
      accessible
      accessibilityRole="image"
      accessibilityLabel="Homingo"
    />
  );
}

const styles = StyleSheet.create({
  logo: {
    // Guards against a parent stretching the lockup in a row layout.
    flexShrink: 0,
  },
});

export default Logo;
